<template>
  <div v-if="mostrar" class="modal-overlay">
    <div class="modal-container">
      <!-- Cabeçalho -->
      <div class="modal-header">
        <h6>Aplicar Recesso</h6>
        <i class="bi bi-x-circle close-icon" @click="fechar"></i>
      </div>

      <!-- Conteúdo -->
      <div class="modal-content">
        <ul class="list-unstyled mb-3">
          <li><strong>Período:</strong> {{ formatarData(recesso.data_inicio) }} &rarr; {{ formatarData(recesso.data_fim) }}</li>
          <li><strong>Descrição:</strong> {{ recesso.descricao }}</li>
          <li><strong>Dias totais de recesso:</strong> {{ totalDias }} dias</li>
        </ul>

        <p>Deseja aplicar este recesso às matrículas?</p>
      </div>

      <!-- Botões -->
      <div class="modal-footer">
        <button class="btn btn-secondary" @click="fechar">Cancelar</button>
        <button class="btn btn-primary" :disabled="isSubmitting" @click="aplicar">
          {{ isSubmitting ? 'Processando…' : 'Aplicar' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, getCurrentInstance } from 'vue'
import axios from '@/services/axios'
import globalUtils from '@/utils/globalUtils'

const instance = getCurrentInstance()
const userName = instance?.appContext.config.globalProperties.$globalState.userName || ''

// Props: mostrar boolean, recesso object
const props = defineProps({
  mostrar: { type: Boolean, default: false },
  recesso: { type: Object, required: true }
})
// Declare que emitimos 'close' e 'aplicado'
const emit = defineEmits(['close', 'aplicado'])

const isSubmitting = ref(false)

// Computed: total de dias no período de recesso
const totalDias = computed(() => {
  const start = new Date(props.recesso.data_inicio)
  const end   = new Date(props.recesso.data_fim)
  return Math.floor((end - start) / (24 * 60 * 60 * 1000)) + 1
})

function formatarData(date) {
  return globalUtils.formatarData(date)
}

function fechar() {
  if (!isSubmitting.value) emit('close')
}

async function aplicar() {
  if (isSubmitting.value) return
  isSubmitting.value = true
  try {
    const response = await axios.post(
      `/configuracoes/recessos/${props.recesso.id}/aplicar`,
      { nome_usuario: userName }
    )
    emit('aplicado', response.data)
    fechar()
  } catch (err) {
    console.error('Erro ao aplicar recesso:', err)
  } finally {
    isSubmitting.value = false
  }
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
}
.modal-container {
  background: #fff;
  width: 100%;
  max-width: 500px;
  border-radius: 4px;
  overflow: hidden;
}
.modal-header {
  background: #f5f5f5;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.close-icon {
  font-size: 1.5rem;
  cursor: pointer;
}
.modal-content {
  padding: 15px;
}
.modal-footer {
  padding: 10px 15px;
  display: flex;
  justify-content: flex-end;
  gap: 8px;
}
.btn {
  min-width: 70px;
  padding: 6px 15px;
  font-size: 14px;
  cursor: pointer;
  border: none;
}
</style>
